export default "__VITE_ASSET__Dvegg88___"